import { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import useFlexible from "@/hooks/useFlexible";

import Course from './pages/Course';
import Address from './pages/Address/List';
import AddressEdit from './pages/Address/Edit';
import Result from './pages/Result';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Course />,
  },
  {
    path: "course",
    element: <Course />,
  },
  {
    path: "address",
    element: <Address />,
  },
  {
    path: "address/add",
    element: <AddressEdit type="add" />,
  },
  {
    path: "address/edit/:id",
    element: <AddressEdit type="edit" />,
  },
  {
    path: "/result",
    element: <Result />,
  },
  {
    path: "*", // 404
    element: (
      <main style={{ padding: "1rem" }}>
        <p>There's nothing here!</p>
      </main>
    )
  }
]);

function App() {
  const { recalc } = useFlexible();

  useEffect(() => {
    setTimeout(() => {
      recalc(); // 解决在APP Ios端因切换横屏导致rem未重新计算的问题
    }, 300);
  }, []);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
